import React, { useRef, useState, useEffect } from 'react'

// next components
import { useRouter } from 'next/router'

// third party components
import { useDispatch } from 'react-redux'

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// components
import { HomePrevButton } from 'components/Button/HomePrevButton'
import { HomeNextButton } from 'components/Button/HomeNextButton'

// resource
import creatorList from 'assets/json/creator-merch/creator-merch.json'

// custom functions
import { useViewport } from 'utils'

// styles
import styles from './index.module.scss'
import CreatorMerchCard from 'components/Card/CreatorMerchCard'
import TrendingCreatorCard from 'components/Card/TrendingCreatorCard'

// call apis
import dashboardAPI from 'apis/dashboard'

const TrendingCreatorSection = props => {
  const {} = props
  const viewport = useViewport()
  const router = useRouter()
  const swiperRef = useRef(null)
  const dispatch = useDispatch()

  const [artistsList, setArtistsList] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    getTopRatedArtistsFromServer('all')
  }, [])

  const getTopRatedArtistsFromServer = period => {
    setIsLoading(true)
    dashboardAPI.getTopRatedArtists(period).then(
      response => {
        setIsLoading(false)
        if (response !== undefined && response !== null) {
          setArtistsList(response.slice(0, 10))
        }
      },
      error => {
        setIsLoading(false)
        console.log(error)
      }
    )
  }

  useEffect(() => {
    if (!isLoading && swiperRef.current && artistsList.length > 0) {
      // Use setTimeout to ensure DOM is fully rendered before repositioning
      const timer = setTimeout(() => {
        if (swiperRef.current) {
          // Force swiper to update and reposition slides after data loads
          swiperRef.current.update()
          swiperRef.current.slideToLoop(0, 0, false)
        }
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isLoading, artistsList.length])

  const handleSeeAll = () => {
    dispatch({ type: 'set', exploreTab: 2 })
    dispatch({ type: 'set', artistSort: 'top' })
    router.push('/explore')
  }

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev()
    }
  }

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext()
    }
  }

  return (
    <section className={styles.container}>
      <div className="w-full g-container justify-between lg:flex hidden">
        <div className={styles.headerContent}>
          <div className={styles.title}>Trending Creators</div>

          <button className={styles.seeAllButton} onClick={handleSeeAll}>
            SEE ALL &gt;&gt;
          </button>
        </div>
        <div className="flex items-end gap-5">
          <HomePrevButton onClick={() => handlePrev()} />

          <HomeNextButton onClick={() => handleNext()} />
        </div>
      </div>

      <div className="w-full g-container justify-between lg:hidden flex">
        <div className={styles.headerContent}>
          <div className={styles.title}>Trending Creators</div>
          <div className={`${styles.description} lg:block hidden`}>
            Explore digital art by Solana’s finest indie creators.
          </div>
        </div>
      </div>

      <div className={`w-full lg:block hidden mt-[45px] ${styles.swiperWrapper}`}>
        <Swiper
          navigation={viewport === 'lg' || viewport === 'xl' || viewport === '2xl'}
          slidesPerView={
            viewport === 'xs'
              ? 2.5
              : viewport === 'sm'
              ? 3
              : viewport === 'md'
              ? 4
              : viewport === 'lg'
              ? 5
              : viewport === 'xl'
              ? 6
              : viewport === '2xl'
              ? 7
              : 7
          }
          spaceBetween={viewport === 'xs' ? 16 : viewport === 'sm' ? 16 : 30}
          loop={true}
          className="heroMobileNavigationSwiper"
          initialSlide={7}
          onSwiper={swiper => {
            swiperRef.current = swiper
            if (artistsList.length > 0 && !isLoading) {
              setTimeout(() => {
                if (swiper) {
                  swiper.update()
                  if (swiper.slideToLoop) {
                    swiper.slideToLoop(0, 0, false)
                  }
                }
              }, 50)
            }
          }}
        >
          {artistsList.map((item, index) => (
            <SwiperSlide key={index}>
              <TrendingCreatorCard artist={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className={`w-full lg:hidden flex gap-[10px] overflow-x-auto mt-[30px] pl-[16px] ${styles.hideScrollbar}`}>
        {artistsList.map((item, index) => (
          <div
            key={index}
            className="max-w-[150px] min-w-[150px] min-h-[150px] max-h-[150px] lg:min-h-[190px] lg:max-w-[242px] lg:min-w-[242px] lg:h-[281px] overflow-hidden"
          >
            <div className="w-full h-full">
              <TrendingCreatorCard artist={item} />
            </div>
          </div>
        ))}
      </div>

      <div className="w-full g-container flex lg:hidden justify-center mt-[30px] px-[20px]">
        <button className={styles.seeMore} onClick={handleSeeAll}>
          See More
        </button>
      </div>
    </section>
  )
}

export default TrendingCreatorSection
